export class MediaDeliveryError extends Error {
  /**
   * @param {string} message
   * @param {'invalid_asset'|'invalid_policy'|'invalid_base_url'} reason
   */
  constructor(message, reason) {
    super(message)
    this.name = 'MediaDeliveryError'
    this.reason = reason
  }
}
